import { SeverityLevel } from '@microsoft/applicationinsights-web';
import { useRef } from 'react';
import { JsonLd } from 'react-schemaorg';
import type { Product } from 'schema-dts';

import { appInsights } from '../../../../appInsights';
import type { ApiProduct } from '../../../../models/ecommerce/product/ApiProduct';
import type { PriceType } from '../../../common/models/priceData/priceData';
import { generateProductJsonLd } from './ProductJsonSchema.utils';

interface ProductJsonLdSchemaProps extends ApiProduct {
    priceType: PriceType;
}

const ProductJsonLd = (product: ProductJsonLdSchemaProps) => {
    const errorLoggedRef = useRef(false); // Ref to keep track if error is logged
    const { hostname } = window.location;
    try {
        const item = generateProductJsonLd(product, product.priceType, hostname);
        return <JsonLd<Product> item={item} />;
    } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
        if (error instanceof Error && !errorLoggedRef.current) {
            appInsights.trackException({
                exception: {
                    ...error,
                    message: `Frontend - Unable to create product JSON-LD schema for ${product.name}`,
                },
                severityLevel: SeverityLevel.Error,
            });
            errorLoggedRef.current = true; // Mark the error as logged
        }
        return null;
    }
};

export default ProductJsonLd;
